module.exports = __webpack_public_path__ + "img/arrow.c7c8d43e.svg";